import { render, staticRenderFns } from "./PictureProgram.vue?vue&type=template&id=2fb6a853&scoped=true"
import script from "./PictureProgram.vue?vue&type=script&lang=js"
export * from "./PictureProgram.vue?vue&type=script&lang=js"
import style0 from "./PictureProgram.vue?vue&type=style&index=0&id=2fb6a853&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6a853",
  null
  
)

export default component.exports